'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct22 from "./scala.-Product22.js";
var $p;
/** @constructor */
function $c_T22(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22) {
  this.po = null;
  this.pz = null;
  this.pD = null;
  this.pE = null;
  this.pF = null;
  this.pG = null;
  this.pH = null;
  this.pI = null;
  this.pJ = null;
  this.pp = null;
  this.pq = null;
  this.pr = null;
  this.ps = null;
  this.pt = null;
  this.pu = null;
  this.pv = null;
  this.pw = null;
  this.px = null;
  this.py = null;
  this.pA = null;
  this.pB = null;
  this.pC = null;
  this.po = _1;
  this.pz = _2;
  this.pD = _3;
  this.pE = _4;
  this.pF = _5;
  this.pG = _6;
  this.pH = _7;
  this.pI = _8;
  this.pJ = _9;
  this.pp = _10;
  this.pq = _11;
  this.pr = _12;
  this.ps = _13;
  this.pt = _14;
  this.pu = _15;
  this.pv = _16;
  this.pw = _17;
  this.px = _18;
  this.py = _19;
  this.pA = _20;
  this.pB = _21;
  this.pC = _22;
}
export { $c_T22 as $c_T22 };
$p = $c_T22.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T22;
/** @constructor */
function $h_T22() {
}
export { $h_T22 as $h_T22 };
$h_T22.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 22;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct22.$f_s_Product22__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-139445068), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T22) && ((((((((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.po, x$0.po) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pz, x$0.pz)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pD, x$0.pD)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pE, x$0.pE)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pF, x$0.pF)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pG, x$0.pG)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pH, x$0.pH)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pI, x$0.pI)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pJ, x$0.pJ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pp, x$0.pp)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pq, x$0.pq)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pr, x$0.pr)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ps, x$0.ps)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pt, x$0.pt)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pu, x$0.pu)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pv, x$0.pv)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pw, x$0.pw)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.px, x$0.px)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.py, x$0.py)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pA, x$0.pA)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pB, x$0.pB)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pC, x$0.pC))));
});
$p.o = (function() {
  return "Tuple22";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((((((((((((("(" + this.po) + ",") + this.pz) + ",") + this.pD) + ",") + this.pE) + ",") + this.pF) + ",") + this.pG) + ",") + this.pH) + ",") + this.pI) + ",") + this.pJ) + ",") + this.pp) + ",") + this.pq) + ",") + this.pr) + ",") + this.ps) + ",") + this.pt) + ",") + this.pu) + ",") + this.pv) + ",") + this.pw) + ",") + this.px) + ",") + this.py) + ",") + this.pA) + ",") + this.pB) + ",") + this.pC) + ")");
});
function $isArrayOf_T22(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eM)));
}
export { $isArrayOf_T22 as $isArrayOf_T22 };
var $d_T22 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T22, "scala.Tuple22", ({
  eM: 1,
  b: 1,
  c: 1,
  rV: 1,
  a: 1
}));
export { $d_T22 as $d_T22 };
